export default __webpack_public_path__ + "static/media/SupplyCamp.07d04f1a.jpg";